import { render, staticRenderFns } from "./carrier-resources.vue?vue&type=template&id=2157de43&"
import script from "./carrier-resources.vue?vue&type=script&lang=js&"
export * from "./carrier-resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports